export const formatThousands = (v, unit) => {
    const digits = String(v ?? '').replace(/[^\d]/g, '');
    if (!digits) return '';
    return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (unit ? ` ${unit}` : '');
};
